import { useEffect } from 'react';

import {
  clientErrorTracker,
  useSoyuzClientConfig
} from '@spotahome/soyuz/client';
import { Mediator } from '@spotahome/soyuz-mediator';

const MAP_LOADED = 'woosmap-map-loaded';
const MAP_SCRIPT_ID = 'woosmap-map-script';
const INIT_CALLBACK_NAME = '__woosmapMapInit';

export const useWoosmapScript = callback => {
  const { woosmapApiKey } = useSoyuzClientConfig();

  useEffect(() => {
    const isWoosmapLoaded =
      window.woosmap && typeof window.woosmap.map !== 'undefined';
    const isScriptAlreadyInjected = document.querySelector(`#${MAP_SCRIPT_ID}`);

    if (isWoosmapLoaded) {
      callback();
      return;
    }

    if (isScriptAlreadyInjected) {
      Mediator.subscribe(MAP_LOADED, callback);
      return;
    }

    Mediator.subscribe(MAP_LOADED, callback);

    window[INIT_CALLBACK_NAME] = () => {
      Mediator.publish(MAP_LOADED);
    };

    const script = document.createElement('script');
    script.id = MAP_SCRIPT_ID;
    script.src = `https://sdk.woosmap.com/map/map.js?key=${woosmapApiKey}&callback=${INIT_CALLBACK_NAME}`;
    script.defer = true;
    script.onerror = error => {
      clientErrorTracker.error({
        error,
        source: 'MapProvider-SDKLoad-Woosmap'
      });
    };
    document.body.appendChild(script);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export default {
  useWoosmapScript
};
